<template>
  <div id="__next">
    <div class="login_modal__overlay" @click="$emit('close'); goNav('/')"></div>
    <div
      class="slide-up pop-up-content 9P login"
      :class="[infoType == 0 ? 'login-modal' : 'register-modal', { 'has-telegram-login': infoType == 0 && telegramConfig.enabled }]"
    >
      <div class="popup-content">
        <div class="auth-modal-content login">
          <div class="modal-body">
            <div class="colse-btn" @click="$emit('close'); goNav('/')">
              <img src="data:image/png;base64,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" alt="close" class="close-icon" />
            </div>
            <div class="head-warp">
              <div class="head-title">{{ infoType == 0 ? $t('Account Login') : $t('Account Registration') }}</div>
              <div class="head-subtitle">
                <span>{{ infoType == 0 ? $t('No account?') : $t('Already have an account?') }}</span>
                <span class="tab-btn" @click="changInfoType(infoType == 0 ? 1 : 0)">{{ infoType == 0 ? $t('Register now') : $t('Login now') }}</span>
              </div>
            </div>
            <div class="form-wrapper">
              <form autocomplete="off" novalidate="novalidate" class="auth-form modal-login-form" v-if="infoType == 0">
                <div class="form-item account-wrapper">
                  <div class="input-with-icon">
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2BAMAAAB+a3fuAAAAKlBMVEUAAACusMaur8atsMatrsWtsMWussessMStscWtsMWuscevssatsMWtsMX8TXQVAAAADXRSTlMA4D+/YKYdhW/vTy/QY/CSsgAAAR5JREFUOMvdkj9Lw0AYh8/GVLAuOrhIIHRzK6g4CQ6uhQ6iXYRTEdcuHQOCZOxHyBcQBFdnP0HaSoz4fBetOXqXu1tCtz7L+8LD/Xt/J9aMu/HHaexXjxmQn/tUJ4KFlB73TsWBq9oZ5WU3hdJduAFXf+UBeo5LKFSdOy5i8F8Dfmy1DbI6F+w3bvGpujOeLBfwrboJA8dNVfdKr4ELmes9G9ylRbl8w5uwyNRWO+TCZqJmduOZWVDN+t4363YEw5dnf7i3VOzbQi0EZlJ42IwWKhZeOunJUIpGtMZHmuu4piJMclMm1CnMEGxGS9eH4wtNClPj/+0Jk0NmOjukFSaxk7lwsg/5spz+M4ETZ99wRbdOYjiHlV246zIS68EvfxflFMGx5wsAAAAASUVORK5CYII=" alt="account" class="input-icon">
                    <input id="account" type="text" inputmode="email" autocomplete="off" :placeholder="$t('Please enter account')" maxlength="20" v-model="loginInfo.name" class="login-input">
                    <span class="clear-btn" v-if="loginInfo.name" @click="loginInfo.name = ''">×</span>
                  </div>
                </div>
                <div class="form-item password-wrapper">
                  <div class="input-with-icon">
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2BAMAAAB+a3fuAAAAIVBMVEUAAACur8etsMWtscSssMWtscWvssitsMWqr8StsMWtsMUG28f7AAAACnRSTlMAPtyBp2cf7xC/flNnLgAAAP1JREFUOMvV1D3vAUEQBvD7vxBUqFCJCMlWl2hEpZOoBJVKo1GJQqEUidBpVewdcs+nxLozuZm7TsFTTfaXzM5mN2t9YZJDda32IunngHt0M8pagMGspC38nKV1Ad0YdACILf8A794t1QcW3KaAbYZV8GRL51msAD6NQts/JWCzwwHjV4cyNx2UJczCloAblDsc+RGcoMy8y9Zwc35KuISoiFD2oY4sPbIptxNZl5tHtuR2JXst1YNKmC5Y+Tirma250eQbYbSQFkbD/UebeSe/0WZezCjGnMf9xxhsK/MxNq8oaRRhipMma3FzyVbcamRJair/ignh84/5ptwAiPhE8pK6/b0AAAAASUVORK5CYII=" alt="password" class="input-icon">
                    <input id="password" autocomplete="off" :placeholder="$t('Please enter login password')" maxlength="18" :type="psw1 ? 'password' : 'text'" v-model="loginInfo.password" class="login-input">
                    <span class="eye-btn" @click="changPsw('psw1')">
                      <img v-if="psw1" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAoCAYAAABjPNNTAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKcSURBVHgB7ZZfchJBEMa7B8JDqlSOsN4AH6NR4QRmjPpKOIHxBElOkHACllclDp4AUJK8khvsDaR80him7V5Y3dldtMQUVabmV5Xszl++6fm6AcDj8Xg8Hs//BCYvp/2zAT/q/Bd+oas3Ld2YwpoxZlCzuME6cAqE7V398ET6lfzrmY87C4HC3h2sDHhBAGvk/YeL5kJglZsBIB0kY7FIEuUpOLx8osrgrRnXYA2Y/vkxkQ0XAmGuCaKUnjnvzKdDheogvwWeKPrW1roRwQ3Dn1lHVMcSlMxQpEg1tN6KHJGCXDtiqcOv1dwiVCHYryL2n70q4ni/1/y6kx3jCE5KpHQiMCdSMOYisGgliYKC/WXh0JLtvtSPh/AXsMeroCpNS5D2vyuQqP1Cb+9n+3HZpr3+eICAdVgKcURxwhtfWrATnhs5o0DBhirdY1E1jk6t4EpdIaj2nj/b6haOFXX2zDlfOxlYL+zDq0aR91W2Q0oPou1kuvscMTllBDcAR3moEPYz+wUzrJiO2CJDGTICpfSAmzh8ws2W1g/ihIkzEpAjjU3IJ9jv4OSDE7Cb3WQvY8Yji/jz88QSd7FyzK+t9EI3u/M+dEpB6jBVPsznpC0ZaWnWzqoqzStFwnB351EjO+fUjPfYkM7NZf1ZdhVj8KtFU0WlnEDhGso1xydEo1f6SZgT0D+TuhssmoWJs6u3Q76dIF2jZ/b6fnqO60miI4h9QlMi1SoSuKDubKLiK8vBPh6lmlUpb0XzuJwdclk7itewX8tQDtPjTiTlVPwI4Q+wH586basuC+exDfjRTNoWvteX7S9C+XFYNKZgBdD9ro+WRdwCTZx1aoNgBVYSqVK2WFikEPlW4h8OcULJNaKFEXg8Ho/H47n1/ADVvw9eCvqfmQAAAABJRU5ErkJggg==" alt="eye-off" class="eye-icon">
                      <img v-else src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAoCAYAAABjPNNTAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAPXSURBVHgB7VhJctpAFP3d4CRVSRyOoNzAXnpK4ATQ8bC1OYHhBIgTBJ/AeJsEC04ArhizNEdQThBclUViI/38BklugdQS9iJZ6FVRoB5f/6mfAMiQIUOGfwYGz4Bl9QtTyG8goMGAyU+BMfbORffHfHEcu8DtI7E7hmdgZZKSGPBXp0SkSI/FdLNwAsAHdIDup/LWBayI1CS/Wt+LnPFGemKxsGmdNri/L4Qo2WkmJJIkyxkue3EOieSktdhEaTD048EGZGf7YruVME5P0uoNya1o0rDCYh/F4QARr+jnIA9vxkJsTpbmW9cbDrgGubpCrv4YQ9zmeF/SWTWWpNW9+ewC1iK62hSPF4dibwAromNdnwBjjQiytoMo4hIskmSnO5TuPVHbpOVymKsKsWVDDCxrZExhauRhSpYtTVYlyxg/iUosloYgubx+KHZb0cT8bHdqalggwJgSpBWXzfJADnPOqWwVw3u5pUUvhUh2esMGrW4+tuCEI1C8RLvBS6o+aJKEiJqivNWM66eqYXpVwwfteb+pxigPCEoXrEBQIongbAy6Zse6qcX1k9VMGqMeoiDXPZceUklKi3gx8kgReVVHcHaoMEEKfqcq3YXonoUGM2yom0YRpa+u0mSsw4taiCSwl6ehDRGaB2K7Cxogg2OVIEdeOhIf2jKeDsRejU5ZV/oL65Cr6NYjF1flOkEDg8bMeLJvFlfhUmPvix0TEiDvauVxsJj1+/NECzLcDY9fgqwG5IWq2kZun3mXewsFi6HyOy2oqN/FdBVgBXBgRmS7d4IghijdNzpUyCGJGKAdzGHs2HeND3lbqc85zm9160XlBYVQc06eQMVXusZWKNSkoNAtyhDU+jfLyMve6FjOs3qjhoug1lX7zr2/0q1H86VhjEcK0PRDKKiTnsrpK/MmdFWVdFrwsju8pfDYgAToLgOJ5fpMeVHZee8/BHVSZuVivcox1v9CIiFucYZcQMgDESCL6AhKjbBcn3kptM/ipG/WdVvGWHgjVo+TVPJadCBv0r1bBsVdnkpqxgmROAmYeC1qiQLrcvxT10kqK7D6aztKugXj4iQgYpVKV3txfKxUi7hTfbSp8DbTquqAGFnchbUKzA9fDPfqr2Ct6KWrr+aVhQjRC2O6/nowE73R0kwqnQd4KOZYjgQvVuLEc5IETPH6QJIKHHPZ/Uvbrfj6gFSf9UmVmqQPr0TJAl2BZ0GSwzN65Wjp4lbFE15pRwZwt0w1tLIoWHXEZOIhOr0cvB2kJfdkkios65b+HPgV+edAnvOfD65ztwZrA128ZciQIcN/jr/3wQA86023OAAAAABJRU5ErkJggg==" alt="eye" class="eye-icon">
                    </span>
                  </div>
                </div>
                
                <div class="remember-forgot">
                  <div class="remember">
                    <input type="checkbox" id="remember" v-model="rememberPassword">
                    <label for="remember">{{ $t('Remember password') }}</label>
                  </div>
                  <div class="forgot">
                    <a href="#">{{ $t('Forgot password') }}</a>
                  </div>
                </div>
                <div class="action-wrapper">
                  <button @click="handleLoginClick" class="login-button" type="button"><span>{{ $t('Login') }}</span></button>
                </div>
                <div v-if="telegramConfig.enabled" class="telegram-quick-login">
                  <div class="quick-login-divider"><span>{{ $t('Quick Login') }}</span></div>
                  <button
                    type="button"
                    class="telegram-login-button"
                    :disabled="telegramLoading || telegramSdkLoading"
                    :aria-label="$t('Quick Login') + ' Telegram'"
                    @click="handleTelegramLoginClick"
                  >
                    <svg viewBox="0 0 48 48" aria-hidden="true">
                      <circle cx="24" cy="24" r="24" fill="#229ED9"/>
                      <path fill="#fff" d="M35.7 13.8 31.9 34c-.3 1.4-1.1 1.7-2.2 1.1l-5.8-4.3-2.8 2.7c-.3.3-.6.6-1.2.6l.4-5.9 10.8-9.8c.5-.4-.1-.7-.7-.3L17 26.5l-5.7-1.8c-1.2-.4-1.3-1.2.3-1.8l22.3-8.6c1-.4 1.9.2 1.8 1.5Z"/>
                    </svg>
                    <span>Telegram</span>
                  </button>
                  <div v-if="telegramLoading || telegramSdkLoading" class="telegram-status">{{ $t('Logging in') }}...</div>
                  <div v-else-if="telegramError" class="telegram-error">{{ telegramError }}</div>
                </div>
                <!-- 去掉登录底栏首存彩金广告图 -->
              </form>
              <form autocomplete="off" class="auth-form modal-regist-form" v-if="infoType == 1" @submit.prevent>
                <div class="form-item account-wrapper">
                  <div class="input-with-icon">
                    <i class="icon-user"></i>
                    <input id="account" type="text" inputmode="email" :placeholder="$t('Set account 6-16 alphanumeric')" maxlength="16" v-model="registerInfo.name" class="login-input">
                    <span class="clear-btn" v-if="registerInfo.name" @click="registerInfo.name = ''">×</span>
                  </div>
                </div>
                <div class="form-item password-wrapper">
                  <div class="input-with-icon">
                    <i class="icon-lock"></i>
                    <input id="password" autocomplete="new-password" :placeholder="$t('Set password 8-16 alphanumeric')" maxlength="16" :type="psw2 ? 'password' : 'text'" v-model="registerInfo.password" class="login-input">
                    <span class="eye-btn" @click="changPsw('psw2')">
                      <i v-if="psw2" class="icon-eye-off"></i>
                      <i v-else class="icon-eye"></i>
                    </span>
                  </div>
                </div>
                <div class="form-item password-wrapper">
                  <div class="input-with-icon">
                    <i class="icon-lock"></i>
                    <input id="password-confirm" autocomplete="new-password" :placeholder="$t('Please enter password again')" maxlength="18" :type="psw2 ? 'password' : 'text'" v-model="registerInfo.confirmPass" class="login-input">
                    <span class="eye-btn" @click="changPsw('psw2')">
                      <i v-if="psw2" class="icon-eye-off"></i>
                      <i v-else class="icon-eye"></i>
                    </span>
                  </div>
                </div>
                <div class="form-item account-wrapper">
                  <div class="input-with-icon">
                    <i class="icon-user"></i>
                    <input :placeholder="$t('Real Name')" maxlength="32" v-model="registerInfo.realname" class="login-input" type="text" />
                    <span class="clear-btn" v-if="registerInfo.realname" @click="registerInfo.realname = ''">×</span>
                  </div>
                </div>
                <div class="form-item password-wrapper">
                  <div class="input-with-icon">
                    <i class="icon-lock"></i>
                    <input :placeholder="$t('Set payment password 8-16 digits')" v-model="registerInfo.paypassword" maxlength="16" :type="psw3 ? 'password' : 'text'" class="login-input" autocomplete="off" />
                    <span class="eye-btn" @click="changPsw('psw3')">
                      <i v-if="psw3" class="icon-eye-off"></i>
                      <i v-else class="icon-eye"></i>
                    </span>
                  </div>
                </div>
                
                <div class="action-wrapper">
                  <button type="button" @click.prevent="handleRegisterClick" class="login-button"><span>{{ $t('Register') }}</span></button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 滑动验证码弹窗 -->
    <div class="captcha-modal" v-if="showCaptchaModal" @click.self="closeCaptchaModal">
      <div class="captcha-modal-content">
        <div class="captcha-modal-body">
          <SliderCaptcha 
            ref="loginSlider"
            @success="onSliderSuccess"
            @fail="onSliderFail"
            @close="closeCaptchaModal"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SliderCaptcha from './SliderCaptcha.vue';

export default {
  name: 'login',
  components: {
    SliderCaptcha
  },
  props: {
    initialType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      registerInfo: {},
      loginInfo: {},
      infoType: 0,
      psw1: true,
      psw2: true,
      psw3: true,
      pid: '',
      rememberPassword: true,
      sliderVerified: false,
      registerSliderVerified: false,
      showCaptchaModal: false,
      pendingLoginInfo: null,
      pendingRegisterInfo: null,
      isRegisterCaptcha: false,
      telegramConfig: {
        enabled: false,
        bot_id: '',
        bot_username: '',
      },
      telegramLoading: false,
      telegramSdkLoading: false,
      telegramSdkPromise: null,
      telegramError: '',
    };
  },
  created() {
    let that = this;
    if (that.initialType !== undefined) {
      that.infoType = that.initialType;
    }
    var query = that.$route.query;
    if (query.type) {
      that.infoType = parseInt(query.type);
    }
    if (query.pid) {
      that.pid = query.pid;
    }
  },
  methods: {
    changPsw(name) {
      this[name] = !this[name];
    },
    changInfoType(type) {
      let that = this;
      if (that.infoType == type) {
        return;
      }
      that.infoType = type;
      that.loginInfo = {};
      that.registerInfo = {};
      that.sliderVerified = false;
      that.registerSliderVerified = false;
      that.telegramError = '';
      this.psw1 = true;
      this.psw2 = true;
      this.psw3 = true;
      
      that.$nextTick(() => {
        if (that.$refs.loginSlider) {
          that.$refs.loginSlider.reset();
        }
        if (that.infoType === 0) {
          that.loadTelegramSdk();
        }
      });
    },
    onSliderSuccess() {
      this.sliderVerified = true;
      console.log('滑动验证成功');
      this.showCaptchaModal = false;
      // 验证成功后执行登录或注册（仅在有待处理信息时）
      if (this.pendingLoginInfo) {
        const info = this.pendingLoginInfo;
        this.pendingLoginInfo = null;
        this.doLogin(info);
      } else if (this.pendingRegisterInfo) {
        const info = this.pendingRegisterInfo;
        this.pendingRegisterInfo = null;
        this.doRegister(info);
      }
    },
    onSliderFail() {
      this.sliderVerified = false;
      console.log('滑动验证失败');
    },
    closeCaptchaModal() {
      this.showCaptchaModal = false;
      this.pendingLoginInfo = null;
      this.pendingRegisterInfo = null;
    },
    handleLoginClick() {
      console.log('========== 登录按钮被点击 ==========');
      this.login();
    },
    handleRegisterClick() {
      console.log('========== 注册按钮被点击 ==========');
      this.register();
    },
    register() {
      let that = this;

      let info = that.registerInfo;
      console.log(info);
      if (!info.name || info.name.length < 6) {
        that.showTost(0, that.$t('Username must be 6-16 alphanumeric characters!'));
        return;
      }
      if (!info.password || info.password.length < 8) {
        that.showTost(0, that.$t('Password must be at least 8 characters!'));
        return;
      }
      if (!info.confirmPass || info.confirmPass != info.password) {
        that.showTost(0, that.$t('Passwords do not match!'));
        return;
      }
      if (!info.realname || info.realname.length < 2) {
        that.showTost(0, that.$t('Please enter your real name!'));
        return;
      }

      if (!info.paypassword || info.paypassword.length < 8) {
        that.showTost(0, that.$t('Payment password must be at least 8 characters!'));
        return;
      }
      
      console.log('=== 准备显示滑动验证 ===');
      console.log('当前 showCaptchaModal:', that.showCaptchaModal);
      
      // 先保存注册信息，然后弹出滑动验证
      that.pendingRegisterInfo = { ...info };
      
      // 强制设置为true
      that.showCaptchaModal = true;
      console.log('设置后 showCaptchaModal:', that.showCaptchaModal);
      
      that.sliderVerified = false;
      that.isRegisterCaptcha = true;
      
      // 确保滑动验证码组件重置
      that.$nextTick(() => {
        console.log('=== nextTick 执行 ===');
        console.log('nextTick 中 showCaptchaModal:', that.showCaptchaModal);
        if (that.$refs.loginSlider) {
          console.log('重置滑动验证码');
          that.$refs.loginSlider.reset();
        }
        // 再次确认弹窗显示状态
        if (!that.showCaptchaModal) {
          console.log('弹窗被意外关闭，重新显示');
          that.showCaptchaModal = true;
        }
      });
    },
    async doRegister(info) {
      let that = this;
      // 必须先通过滑动验证，防止绕过弹窗直接调注册
      if (!that.sliderVerified) {
        that.showTost(0, that.$t('Please complete verification first!'));
        return;
      }
      that.showLoading();
      const registerPayload = { ...info };
      if (that.pid) registerPayload.pid = that.pid;

      try {
        const res = await that.$apiFun.register(registerPayload);
        if (res.code != 200) {
          that.sliderVerified = false;
          that.showTost(0, res.message || that.$t('Registration failed. Please try again.'));
          return;
        }

        const responseData = res.data || {};
        const token = responseData.api_token || responseData.new_api_token || '';
        if (!token) {
          that.sliderVerified = false;
          that.showTost(0, that.$t('Registration succeeded but login failed. Please contact customer service.'));
          return;
        }

        // 注册成功直接写入登录态，无需再登录一次
        sessionStorage.setItem('token', token);
        that.$store.commit('changToken');

        let userInfo = that.buildUserInfoFromAuth(responseData, registerPayload.name);
        if (userInfo.vip === undefined || userInfo.vip === null || userInfo.vip === '') {
          userInfo.vip = 1;
        }
        that.saveUserInfo(userInfo);

        try {
          const balanceRes = await that.$apiFun.post('/api/balance', {});
          if (balanceRes.code == 200 && balanceRes.data && balanceRes.data.balance !== undefined) {
            userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}') || userInfo;
            userInfo.balance = balanceRes.data.balance;
            if (!userInfo.username) userInfo.username = registerPayload.name;
            that.saveUserInfo(userInfo);
          }
        } catch (balanceErr) {
          console.error('注册后获取余额失败:', balanceErr);
        }

        await that.fetchFullUserInfo(registerPayload.name);
        that.openDaoTime();
        that.showTost(1, that.$t('Registration successful'));
        that.$emit('success', {
          type: 'register',
          register_gift: responseData.register_gift || null,
        });
        that.$emit('close');
        if (that.$route && that.$route.path !== '/') {
          that.$router.replace('/');
        }
      } catch (err) {
        console.error('注册失败:', err);
        that.sliderVerified = false;
        that.showTost(0, that.$t('Registration failed. Please try again.'));
      } finally {
        that.hideLoading();
      }
    },
    login() {
      console.log('========== 登录按钮被点击 ==========');
      let that = this;
      let info = that.loginInfo;
      console.log('登录信息:', info);
      
      if (!info.name || !info.password) {
        that.showTost(0, that.$t('Please enter account and password!'));
        return;
      }
      
      // 先保存登录信息，然后弹出滑动验证
      that.pendingLoginInfo = { ...info };
      that.showCaptchaModal = true;
      that.sliderVerified = false;
      
      // 重置滑动验证码
      that.$nextTick(() => {
        if (that.$refs.loginSlider) {
          that.$refs.loginSlider.reset();
        }
      });
    },
    // 优先走 App 根组件的 loading/toast/定时刷新，保证注册后立刻处于登录态 UI
    getAppRoot() {
      let p = this.$parent;
      while (p) {
        if (typeof p.showTost === 'function' || typeof p.openDaoTime === 'function') return p;
        p = p.$parent;
      }
      return this.$root;
    },
    showLoading() {
      const app = this.getAppRoot();
      if (app && typeof app.showLoading === 'function') app.showLoading();
    },
    hideLoading() {
      const app = this.getAppRoot();
      if (app && typeof app.hideLoading === 'function') app.hideLoading();
    },
    showTost(type, message) {
      const app = this.getAppRoot();
      if (app && typeof app.showTost === 'function' && app !== this) {
        app.showTost(type, message);
        return;
      }
      alert(message);
    },
    openDaoTime() {
      const app = this.getAppRoot();
      if (app && typeof app.openDaoTime === 'function' && app !== this) {
        app.openDaoTime();
      }
    },
    goNav(path) {
      this.$router.push(path);
    },
    // 登录/注册接口字段不统一：优先嵌套，否则用顶层 data，并保证 username 立刻有值
    buildUserInfoFromAuth(data, fallbackName) {
      const raw = (data && (data.userInfo || data.user)) ? (data.userInfo || data.user) : (data || {});
      const userInfo = { ...raw };
      delete userInfo.password;
      delete userInfo.paypwd;
      delete userInfo.register_gift;

      userInfo.username = userInfo.username || userInfo.name || userInfo.account || fallbackName || '';
      if (userInfo.current_vip != null && userInfo.current_vip !== '') {
        const vipStr = String(userInfo.current_vip);
        const vipIndex = vipStr.indexOf('P');
        userInfo.vip = vipIndex >= 0 ? vipStr.substr(vipIndex + 1) : vipStr;
      }
      if (userInfo.vip === undefined || userInfo.vip === null || userInfo.vip === '') {
        userInfo.vip = raw.vip != null ? raw.vip : 0;
      }
      if (userInfo.balance === undefined || userInfo.balance === null || userInfo.balance === '') {
        userInfo.balance = '0.00';
      }
      return userInfo;
    },
    saveUserInfo(userInfo) {
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
      this.$store.commit('changUserInfo');
    },
    async fetchFullUserInfo(fallbackName) {
      try {
        const res = await this.$apiFun.post('/api/user', {});
        if (res.code !== 200 || !res.data) return null;
        const existing = JSON.parse(localStorage.getItem('userInfo') || '{}') || {};
        const userInfo = { ...res.data };
        if (userInfo.current_vip) {
          const vipStr = String(userInfo.current_vip);
          const vipIndex = vipStr.indexOf('P');
          userInfo.vip = vipIndex >= 0 ? vipStr.substr(vipIndex + 1) : vipStr;
        }
        if (!userInfo.username) {
          userInfo.username = existing.username || fallbackName || '';
        }
        if (userInfo.balance === undefined || userInfo.balance === null) {
          userInfo.balance = existing.balance != null ? existing.balance : '0.00';
        }
        this.saveUserInfo(userInfo);
        return userInfo;
      } catch (err) {
        console.error('拉取完整用户信息失败:', err);
        return null;
      }
    },
    async doLogin(info) {
      const that = this;
      that.showLoading();
      try {
        const res = await that.$apiFun.login(info);
        if (res.code !== 200) {
          that.showTost(0, that.$t('Incorrect account or password!'));
          return;
        }

        const token = (res.data && (res.data.api_token || res.data.new_api_token)) || '';
        if (!token) {
          that.showTost(0, that.$t('Incorrect account or password!'));
          return;
        }

        sessionStorage.setItem('token', token);
        that.$store.commit('changToken');

        // 立刻写入用户名，避免首页/我的显示空白，必须刷新才有
        let userInfo = that.buildUserInfoFromAuth(res.data, info.name);
        that.saveUserInfo(userInfo);

        try {
          const balanceRes = await that.$apiFun.post('/api/balance', {});
          if (balanceRes.code == 200 && balanceRes.data && balanceRes.data.balance !== undefined) {
            userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}') || userInfo;
            userInfo.balance = balanceRes.data.balance;
            if (!userInfo.username) userInfo.username = info.name;
            that.saveUserInfo(userInfo);
          }
        } catch (balanceErr) {
          console.error('登录后获取余额失败:', balanceErr);
        }

        await that.fetchFullUserInfo(info.name);
        that.openDaoTime();
        that.$emit('success', { type: 'login' });
        that.$emit('close');
        if (that.$route && that.$route.path !== '/') {
          that.$router.replace('/');
        }
      } catch (err) {
        console.error('登录失败:', err);
        that.showTost(0, that.$t('Incorrect account or password!'));
      } finally {
        that.hideLoading();
      }
    },
    async loadTelegramConfig() {
      try {
        const res = await this.$apiFun.get('/api/telegram/config');
        if (res.code === 200 && res.data) {
          this.telegramConfig = {
            enabled: Boolean(res.data.enabled),
            bot_id: String(res.data.bot_id || ''),
            bot_username: String(res.data.bot_username || '').replace(/^@/, ''),
          };
          if (this.telegramConfig.enabled && this.infoType === 0) {
            this.loadTelegramSdk();
          }
        }
      } catch (err) {
        console.error('读取 Telegram 登录配置失败:', err);
      }
    },
    loadTelegramSdk() {
      if (window.Telegram && window.Telegram.Login) {
        return Promise.resolve();
      }
      if (this.telegramSdkPromise) return this.telegramSdkPromise;

      this.telegramSdkPromise = new Promise((resolve, reject) => {
        let script = document.getElementById('telegram-login-sdk');
        if (!script) {
          script = document.createElement('script');
          script.id = 'telegram-login-sdk';
          script.async = true;
          script.src = 'https://telegram.org/js/telegram-widget.js?22';
          document.head.appendChild(script);
        }
        script.addEventListener('load', () => resolve(), { once: true });
        script.addEventListener('error', () => reject(new Error('Telegram SDK load failed')), { once: true });
      });
      return this.telegramSdkPromise;
    },
    async handleTelegramLoginClick() {
      if (this.telegramLoading || this.telegramSdkLoading) return;
      this.telegramError = '';
      this.telegramSdkLoading = true;
      try {
        await this.loadTelegramSdk();
        this.telegramSdkLoading = false;
        if (!window.Telegram || !window.Telegram.Login || !this.telegramConfig.bot_id) {
          throw new Error('Telegram SDK unavailable');
        }
        window.Telegram.Login.auth({
          bot_id: Number(this.telegramConfig.bot_id),
          request_access: 'write',
        }, (user) => {
          if (user && user.id) {
            this.handleTelegramAuth(user);
          } else {
            this.telegramError = this.$t('Telegram login failed');
          }
        });
      } catch (err) {
        console.error('打开 Telegram 授权失败:', err);
        this.telegramError = this.$t('Telegram login failed');
        this.telegramSdkPromise = null;
        const failedScript = document.getElementById('telegram-login-sdk');
        if (failedScript && failedScript.parentNode) {
          failedScript.parentNode.removeChild(failedScript);
        }
      } finally {
        this.telegramSdkLoading = false;
      }
    },
    async handleTelegramAuth(telegramUser) {
      if (this.telegramLoading || !telegramUser || !telegramUser.id) return;

      this.telegramLoading = true;
      this.telegramError = '';
      this.showLoading();
      try {
        const payload = { ...telegramUser };
        if (this.pid) payload.pid = this.pid;
        const res = await this.$apiFun.post('/api/telegram/auth', payload);
        const token = res.data && (res.data.api_token || res.data.new_api_token);
        if (res.code !== 200 || !token) {
          this.telegramError = res.message || this.$t('Telegram login failed');
          return;
        }

        sessionStorage.setItem('token', token);
        this.$store.commit('changToken');
        let userInfo = this.buildUserInfoFromAuth(res.data, res.data.username);
        this.saveUserInfo(userInfo);
        await this.fetchFullUserInfo(userInfo.username);
        this.openDaoTime();
        this.showTost(1, res.data.created
          ? this.$t('Telegram registration successful')
          : this.$t('Login successful'));
        this.$emit('success', {
          type: res.data.created ? 'register' : 'login',
          register_gift: res.data.register_gift || null,
        });
        this.$emit('close');
        if (this.$route && this.$route.path !== '/') {
          this.$router.replace('/');
        }
      } catch (err) {
        console.error('Telegram 登录失败:', err);
        this.telegramError = this.$t('Telegram login failed');
      } finally {
        this.telegramLoading = false;
        this.hideLoading();
      }
    },
  },
  mounted() {
    this.loadTelegramConfig();
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../static/css/79a97583f57023fe4fa8.css';
@import '../../static/css/438b8f8fe59c79885d4c.css';
@import '../../static/css/4186aeadfd68d65ea7ad.css';
#__next {
  width: 100vw;
  
  position: relative;
}
.login_modal__overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9998;
  animation: fadeIn 0.3s ease;
}
.slide-up {
  position: fixed;
  left: 0;
  right: 0;
  z-index: 9999;
  background-color: #fff;
  border-radius: 16px 16px 0 0;
  overflow: hidden;
  animation: slideUp 0.3s ease;
}
.login-modal {
  top: calc(100% - 400px);
}
.login-modal.has-telegram-login {
  top: auto;
  bottom: 0;
  max-height: 92vh;
  overflow-y: auto;
}
.register-modal {
  top: calc(100% - 510px);
}
.pop-up-content {
  background: linear-gradient(to top, #fff, #ebf1f9 45%, #e7eef8);
  background-position: 80% 6%;
  background-size: 100% 100%;
}
.popup-content {
  padding: 20px;
}
.auth-modal-content {
  width: 100%;
}
.modal-body {
  width: 100%;
}
.colse-btn {
  position: absolute;
  top: 5px;
  right: 15px;
  z-index: 10000;
  cursor: pointer;
}
.fit-image {
  width: 35px;
  height: 50px;
  object-fit: contain;
}
.head-warp {
  margin-bottom: 20px;
  text-align: left;
}
.head-title {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
}
.head-subtitle {
  color: #666;
  font-size: 0.44rem !important;
  span {
    font-size: 0.44rem !important;
  }
}
.tab-btn {
  color: #338ddd;
    cursor: pointer;
    margin-left: -7px;
}
.form-wrapper {
  width: 100%;
}
.auth-form {
  width: 100%;
}
.form-item {
  margin-bottom: 15px;
}
.input-with-icon {
  position: relative;
  display: flex;
  align-items: center;
  border: 1px solid #cfd0d1;
  border-radius: 8px;
  padding: 0 15px;
  height: 48px;
  background-color: #fff;
  transition: border-color 0.3s;
  background-color: rgb(248 251 255 / var(--un-bg-opacity));
  &:focus-within {
    border-color: #6c757d;
  }
}
.icon-user,
.icon-lock,
.icon-code {
  font-size: 18px;
  color: #6c757d;
  margin-right: 10px;
  flex-shrink: 0;
}
.icon-user {
  width: 18px;
  height: 18px;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2BAMAAAB+a3fuAAAAKlBMVEUAAACusMaur8atsMatrsWtsMWussessMStscWtsMWuscevssatsMWtsMX8TXQVAAAADXRSTlMA4D+/YKYdhW/vTy/QY/CSsgAAAR5JREFUOMvdkj9Lw0AYh8/GVLAuOrhIIHRzK6g4CQ6uhQ6iXYRTEdcuHQOCZOxHyBcQBFdnP0HaSoz4fBetOXqXu1tCtz7L+8LD/Xt/J9aMu/HHaexXjxmQn/tUJ4KFlB73TsWBq9oZ5WU3hdJduAFXf+UBeo5LKFSdOy5i8F8Dfmy1DbI6F+w3bvGpujOeLBfwrboJA8dNVfdKr4ELmes9G9ylRbl8w5uwyNRWO+TCZqJmduOZWVDN+t4363YEw5dnf7i3VOzbQi0EZlJ42IwWKhZeOunJUIpGtMZHmuu4piJMclMm1CnMEGxGS9eH4wtNClPj/+0Jk0NmOjukFSaxk7lwsg/5spz+M4ETZ99wRbdOYjiHlV246zIS68EvfxflFMGx5wsAAAAASUVORK5CYII=);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  display: inline-block;
}
.icon-user::before {
  content: "";
}
.icon-lock {
  width: 18px;
  height: 18px;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2BAMAAAB+a3fuAAAAIVBMVEUAAACur8etsMWtscSssMWtscWvssitsMWqr8StsMWtsMUG28f7AAAACnRSTlMAPtyBp2cf7xC/flNnLgAAAP1JREFUOMvV1D3vAUEQBvD7vxBUqFCJCMlWl2hEpZOoBJVKo1GJQqEUidBpVewdcs+nxLozuZm7TsFTTfaXzM5mN2t9YZJDda32IunngHt0M8pagMGspC38nKV1Ad0YdACILf8A794t1QcW3KaAbYZV8GRL51msAD6NQts/JWCzwwHjV4cyNx2UJczCloAblDsc+RGcoMy8y9Zwc35KuISoiFD2oY4sPbIptxNZl5tHtuR2JXst1YNKmC5Y+Tirma250eQbYbSQFkbD/UebeSe/0WZezCjGnMf9xxhsK/MxNq8oaRRhipMma3FzyVbcamRJair/ignh84/5ptwAiPhE8pK6/b0AAAAASUVORK5CYII=);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  display: inline-block;
}
.icon-lock::before {
  content: "";
}
.icon-code::before {
  content: "🔐";
}
.icon-eye {
  width: 18px;
  height: 18px;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAoCAYAAABjPNNTAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAPXSURBVHgB7VhJctpAFP3d4CRVSRyOoNzAXnpK4ATQ8bC1OYHhBIgTBJ/AeJsEC04ArhizNEdQThBclUViI/38BklugdQS9iJZ6FVRoB5f/6mfAMiQIUOGfwYGz4Bl9QtTyG8goMGAyU+BMfbORffHfHEcu8DtI7E7hmdgZZKSGPBXp0SkSI/FdLNwAsAHdIDup/LWBayI1CS/Wt+LnPFGemKxsGmdNri/L4Qo2WkmJJIkyxkue3EOieSktdhEaTD048EGZGf7YruVME5P0uoNya1o0rDCYh/F4QARr+jnIA9vxkJsTpbmW9cbDrgGubpCrv4YQ9zmeF/SWTWWpNW9+ewC1iK62hSPF4dibwAromNdnwBjjQiytoMo4hIskmSnO5TuPVHbpOVymKsKsKsWVDDCxrZExhauRhSpYtTVYlyxg/iUosloYgubx+KHZb0cT8bHdqalggwJgSpBWXzfJADnPOqWwVw3u5pUUvhUh2esMGrW4+tuCEI1C8RLvBS6o+aJKEiJqivNWM66eqYXpVwwfteb+pxigPCEoXrEBQIongbAy6Zse6qcX1k9VMGqMeoiDXPZceUklKi3gx8kgReVVHcHaoMEEKfqcq3YXonoUGM2yom0YRpa+u0mSsw4taiCSwl6ehDRGaB2K7Cxogg2OVIEdeOhIf2jKeDsRejU5ZV/oL65Cr6NYjF1flOkEDg8bMeLJvFlfhUmPvix0TEiDvauVxsJj1+/NECzLcDY9fgqwG5IWq2kZun3mXewsFi6HyOy2oqN/FdBVgBXBgRmS7d4IghijdNzpUyCGJGKAdzGHs2HeND3lbqc85zm9160XlBYVQc06eQMVXusZWKNSkoNAtyhDU+jfLyMve6FjOs3qjhoug1lX7zr2/0q1H86VhjEcK0PRDKKiTnsrpK/MmdFWVdFrwsju8pfDYgAToLgOJ5fpMeVHZee8/BHVSZuVivcox1v9CIiFucYZcQMgDESCL6AhKjbBcn3kptM/ipG/WdVvGWHgjVo+TVPJadCBv0r1bBsVdnkpqxgmROAmYeC1qiQLrcvxT10kqK7D6aztKugXj4iQgYpVKV3txfKxUi7hTfbSp8DbTquqAGFnchbUKzA9fDPfqr2Ct6KWrr+aVhQjRC2O6/nowE73R0kwqnQd4KOZYjgQvVuLEc5IETPH6QJIKHHPZ/Uvbrfj6gFSf9UmVmqQPr0TJAl2BZ0GSwzN65Wjp4lbFE15pRwZwt0w1tLIoWHXEZOIhOr0cvB2kJfdkkios65b+HPgV+edAnvOfD65ztwZrA128ZciQIcN/jr/3wQA86023OAAAAABJRU5ErkJggg==);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  display: inline-block;
}
.icon-eye::before {
  content: "";
}
.icon-eye-off {
  width: 18px;
  height: 18px;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAoCAYAAABjPNNTAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKcSURBVHgB7ZZfchJBEMa7B8JDqlSOsN4AH6NR4QRmjPpKOIHxBElOkHACllclDp4AUJK8khvsDaR80him7V5Y3dldtMQUVabmV5Xszl++6fm6AcDj8Xg8Hs//BCYvp/2zAT/q/Bd+oas3Ld2YwpoxZlCzuME6cAqE7V398ET6lfzrmY87C4HC3h2sDHhBAGvk/YeL5kJglZsBIB0kY7FIEuUpOLx8osrgrRnXYA2Y/vkxkQ0XAmGuCaKUnjnvzKdDheogvwWeKPrW1roRwQ3Dn1lHVMcSlMxQpEg1tN6KHJGCXDtiqcOv1dwiVCHYryL2n70q4ni/1/y6kx3jCE5KpHQiMCdSMOYisGgliYKC/WXh0JLtvtSPh/AXsMeroCpNS5D2vyuQqP1Cb+9n+3HZpr3+eICAdVgKcURxwhtfWrATnhs5o0DBhirdY1E1jk6t4EpdIaj2nj/b6haOFXX2zDlfOxlYL+zDq0aR91W2Q0oPou1kuvscMTllBDcAR3moEPYz+wUzrJiO2CJDGTICpfSAmzh8ws2W1g/ihIkzEpAjjU3IJ9jv4OSDE7Cb3WQvY8Yji/jz88QSd7FyzK+t9EI3u/M+dEpB6jBVPsznpC0ZaWnWzqoqzStFwnB351EjO+fUjPfYkM7NZf1ZdhVj8KtFU0WlnEDhGso1xydEo1f6SZgT0D+TuhssmoWJs6u3Q76dIF2jZ/b6fnqO60miI4h9QlMi1SoSuKDubKLiK8vBPh6lmlUpb0XzuJwdclk7itewX8tQDtPjTiTlVPwI4Q+wH586basuC+exDfjRTNoWvteX7S9C+XFYNKZgBdD9ro+WRdwCTZx1aoNgBVYSqVK2WFikEPlW4h8OcULJNaKFEXg8Ho/H47n1/ADVvw9eCvqfmQAAAABJRU5ErkJggg==);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  display: inline-block;
}
.icon-eye-off::before {
  content: "";
}
.close-icon {
  width: 34px;
  height: 34px;
  object-fit: contain;
  display: block;
}
.input-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
  margin-right: 10px;
  flex-shrink: 0;
}
.eye-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
  cursor: pointer;
}
.login-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 16px;
  color: #333;
  background: transparent;
  &::placeholder {
    color: #adb5bd;
  }
}
.clear-btn {
  color: #adb5bd;
  cursor: pointer;
  font-size: 26px;
  margin-left: 10px;
  &:hover {
    color: #6c757d;
  }
}
.eye-btn {
  color: #adb5bd;
  cursor: pointer;
  font-size: 18px;
  margin-left: 10px;
  &:hover {
    color: #6c757d;
  }
}
.slider-captcha-wrapper {
  margin-bottom: 15px;
}
.remember-forgot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  font-size: 14px;
}
.remember {
  display: flex;
  align-items: center;
  font-size: 16px !important;
  input[type="checkbox"] {
    margin-right: 5px;
    transform: scale(1.2);
  }
  label {
    color: #666;
    cursor: pointer;
    font-size: 16px !important;
  }
}
.forgot a {
  color: #6c757d;
  text-decoration: none;
  font-size: 16px !important;
  &:hover {
    text-decoration: underline;
  }
}
.action-wrapper {
  margin-top: 20px;
  margin-bottom: 15px;
  position: relative;
  z-index: 1001;
}
.login-button {
  width: 100%;
  height: 48px;
  background: linear-gradient(135deg, #b87333, #8f501f);
  color: #fff;
  border: none;
  border-radius: 8px;

  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;
  position: relative;
  z-index: 1002;
  pointer-events: auto;
  display: block;
  &:hover {
    background: linear-gradient(135deg, #a9622a, #7f461c);
  }
  &:active {
    background: #744016;
  }
}
.telegram-quick-login {
  margin-top: 6px;
  text-align: center;
}
.quick-login-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #8b96a8;
  font-size: 14px;
  margin-bottom: 12px;

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #ccd5e3;
  }
}
.telegram-login-button {
  min-width: 76px;
  min-height: 70px;
  padding: 0;
  margin: 0 auto;
  border: 0;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  color: #4f5b6d;
  font-size: 13px;
  cursor: pointer;

  svg {
    width: 48px;
    height: 48px;
    flex: 0 0 48px;
    filter: drop-shadow(0 4px 8px rgba(34, 158, 217, 0.25));
  }

  > span {
    display: block !important;
    min-height: 18px;
    color: #4f5b6d !important;
    font-size: 13px !important;
    line-height: 18px !important;
    opacity: 1 !important;
    visibility: visible !important;
  }

  &:disabled {
    opacity: 0.55;
    cursor: wait;
  }

  &:not(:disabled):active {
    transform: scale(0.96);
  }
}
.telegram-status,
.telegram-error {
  min-height: 20px;
  margin-top: 4px;
  font-size: 13px;
}
.telegram-status {
  color: #229ed9;
}
.telegram-error {
  display: block;
  padding: 0 8px 8px;
  color: #d14343 !important;
  line-height: 18px;
  white-space: normal;
  overflow-wrap: anywhere;
}
.pg-auth-bouns {
  width: 100%;
  height: 48px;
  object-fit: contain;
  border-radius: 8px;
}
.login_visitorBtn__2xo1h {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}
.login_visitorBtn__2xo1h a {
  color: #666;
  font-size: 14px;
  text-decoration: none;
  &:hover {
    color: #6f42c1;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

// 滑动验证码弹窗样式
.captcha-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.3s ease;
}

.captcha-modal-content {
 
  border-radius: 30px;
  width: 90%;
  max-width: 360px;
  overflow: hidden;
  animation: slideUp 0.3s ease;
}

.captcha-modal-body {
  padding: 20px;
}

.captcha-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
  
  h3 {
    margin: 0;
    font-size: 18px;
    color: #333;
  }
  
  .close-btn {
    font-size: 24px;
    color: #999;
    cursor: pointer;
    
    &:hover {
      color: #666;
    }
  }
}

.captcha-modal-body {

  
  .captcha-tip {
    text-align: center;
    color: #666;
    margin-bottom: 15px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue